import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import MainLayout from './Layout/MainLayout';
import Commandes from './pages/Commandes/Commandes';
import SuiviDeCommande from './pages/SuiviDeCommande/SuiviDeCommande';
import SuiviOperation from './pages/SuiviOperation/SuiviOperation';
import FicheContact from './pages/FicheContact/FicheContact';
import Profil from './pages/Profil/Profil';
import Mentions from './pages/Mentions/Mentions';
import Aide from './pages/Aide/Aide';
import Publications from './pages/Publications/Publications';
import MentionsLegales from './pages/MentionsLegales/MentionsLegales';
import Securite from './pages/Securite/Securite';
import Annuaire from './pages/Annuaire/Annuaire';
import PrivateRoute from './composants/PrivateRoute/PrivateRoute';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import CGVAccept from './pages/CGVAccept/CGVAccept';
import Operation from './pages/Operation/Operation';
import { NotificationsProvider } from './contexts/NotificationsContextType';
import Assistance from './pages/Assistance/Assistance';

function App() {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <div className="App">
          <main className="content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/cgv" element={<CGVAccept />} />
              <Route path="/securite" element={<Securite />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Routes>
                        <Route path="/" element={<Navigate to="/commandes" />} />
                        <Route path="/operations" element={<Operation />} />
                        <Route path="/commandes" element={<Commandes />} />
                        <Route path="commandes/:id" element={<SuiviDeCommande />} />
                        <Route path="operations/:id" element={<SuiviOperation />} />
                        <Route path="/annuaire" element={<Annuaire />} />
                        <Route path="/contact/:id" element={<FicheContact />} />
                        <Route path="/profil" element={<Profil />} />
                        <Route path="/assistance" element={<Assistance />} />
                        <Route path="/mentions" element={<Mentions />} />
                        <Route path="/aide" element={<Aide />} />
                        <Route path="/publications" element={<Publications />} />
                      </Routes>
                    </MainLayout>
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
        </div>
      </NotificationsProvider>
    </AuthProvider>
  );
}

export default App;
